import { render, staticRenderFns } from "./ResourseUtilization.vue?vue&type=template&id=a45c923e"
import script from "./ResourseUtilization.vue?vue&type=script&lang=js"
export * from "./ResourseUtilization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports